/**
 * NOTE: `setPremiumCheck` (mobile navigation-flow flag) dropped — `proceed`
 * navigates straight to Home, which is the web equivalent of "enter the main
 * app".
 */
import React, { useEffect, useState } from 'react';

import CSSModule from 'react-css-modules';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { CouponLogoIcon } from 'components/Icons';
import { actions as businessDetailsActions } from 'coupon-common/src/modules/businesses/details';
import { actions as followActions } from 'coupon-common/src/modules/businesses/follow';

import { RouteNames } from '../../../constants';
import styles from './FreePremiumScreen.module.scss';

const FreePremiumScreen = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isFollowing, setIsFollowing] = useState(false);

  const business = useSelector(state => state.signup.business);
  const referrer = useSelector(state => state.signup.premiumSponsor);

  const businessDetailsState = useSelector(state => state.businesses.details);
  const fullBusiness = business?.id ? businessDetailsState?.[business.id] : null;

  useEffect(() => {
    if (business?.id) {
      dispatch(businessDetailsActions.getDetail(business.id));
    }
  }, [business?.id, dispatch]);

  const handleFollow = async () => {
    if (business?.id) {
      dispatch(followActions.followBusinessRequest({ business_id: business.id }));
      dispatch(followActions.getFollowedBusinessesRequest());
      setIsFollowing(true);
    }
  };

  const membershipSource = business?.name || referrer || 'Unknown';

  const proceed = () => navigate(RouteNames.HOME);

  return (
    <div styleName="page">
      <div styleName="content">
        <div styleName="logo-wrap">
          <CouponLogoIcon width={170} height={81} />
        </div>

        <h1 styleName="title">
          {intl.formatMessage({ id: 'freePremium.welcome', defaultMessage: 'Welcome to Premium!' })}
        </h1>
        <p styleName="subtitle">
          {intl.formatMessage({
            id: 'freePremium.message',
            defaultMessage: 'You have been given a Free Premium Membership for one year from',
          })}
        </p>

        {fullBusiness?.data?.logo && (
          <img src={fullBusiness.data.logo} alt={membershipSource} styleName="business-logo" />
        )}

        <p styleName="business-name">{membershipSource}</p>

        {business && business.name && (
          <button type="button" styleName="follow-btn" onClick={handleFollow} disabled={isFollowing}>
            {isFollowing
              ? intl.formatMessage({ id: 'freePremium.following', defaultMessage: 'Following' })
              : intl.formatMessage({ id: 'freePremium.follow', defaultMessage: 'Follow' })}
          </button>
        )}

        <button type="button" styleName="proceed-btn" onClick={proceed}>
          {intl.formatMessage({ id: 'freePremium.proceed', defaultMessage: 'Proceed' })}
        </button>
      </div>
    </div>
  );
};

export default CSSModule(FreePremiumScreen, styles, { allowMultiple: true });
